/**
 * Which groups are open. `manualKeys` is what the user toggled since the last
 * filter or search change; `null` means "no manual choice", so the default
 * applies: all closed for "Alles" without search, otherwise every group with
 * hits open. The caller resets `manualKeys` to `null` on every filter or
 * search change.
 */
export function resolveOpenKeys(
  manualKeys: string[] | null,
  isNarrowed: boolean,
  visibleKeys: string[],
): string[] {
  if (manualKeys !== null) return manualKeys;
  return isNarrowed ? visibleKeys : [];
}
